module.exports = __webpack_public_path__ + "img/tkd.c3db5bf9.jpg";